import { useContext, useEffect, useState } from "react";

import { Col, Dropdown, Form, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import DashboardContext from "../../../Context";

import ModalDelete from "../ModalDelete";

export default function TabelbodyFinance({ item, number, handeldeleteitem, page, arryheder, urldata, arryactions, isCheck, handelCheckBox }) {

    const { accessPage, handelEdit, handelAdd, handelIdview, handelloding, handeldmicro, handelidshowitem } = useContext(DashboardContext);

    const [keyarry, setKeyarry] = useState([]);

    const { location } = useHistory()

    const [moreitem, setMoreitem] = useState(false)

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = () => setShow(true)

    const handeldelete = () => {
        handeldeleteitem()
        handleClose()
    }


    useEffect(() => {
        if (item) {
            let mytd = []
            for (const property in item) {
                if (item[property] === item.id) {

                }
                else if (item[property] === item.customerId) {

                }
                else {

                    mytd.push(item[property])
                }

            }
            setKeyarry(mytd)
        }
        return () => {

        }
    }, [])


    const handelEditbtn = (id) => {
        if (urldata) {
            handeldmicro(true)
        }
        else {
            handelAdd(true)
        }
        handelEdit(id)
        handelloding(true)
    }

    const handelview = id => {
        handelIdview(id)
        handelloding(true)

    }
    const handelshowWork = (id) => {
        if (urldata) {
            handeldmicro(true)
        }
        else {
            handelAdd(true)
        }
        handelidshowitem(id)
        handelloding(true)
    }

    const handelCopy = (name) => {
        navigator.clipboard.writeText(name)
    }



    return (
        <>
            <tr style={
                item.hasOwnProperty('transactionStatus') ?
                    item.transactionStatus === 2 ? { backgroundColor: '#5bff0047' } : { backgroundColor: '#ff1e0047' }
                    : item.hasOwnProperty('isPaid') ? item.isPaid ? { backgroundColor: '#5bff0047' } : { backgroundColor: '#ff1e0047' }
                        : item.hasOwnProperty('totalDebt') ? item.totalDebt > -1 ? { backgroundColor: '#5bff0047' } : { backgroundColor: '#ff1e0047' }
                            : null
            } >
                <td className='morerow' style={{ border: '1px solid #130101' }} >
                    {
                        isCheck ?
                            item.isPaid ? null : <input type="checkbox" className='ml-3 FinanceCheck' value={item.id} onChange={handelCheckBox} />
                            : null
                    }
                    {
                        keyarry.length > 0 ?
                            keyarry.length > 7 ?
                                <span onClick={() => setMoreitem(!moreitem)} className='ml-2' >
                                    {moreitem ? <i className="mdi mdi-arrow-up-bold-circle"></i> :
                                        <i className="mdi mdi-arrow-down-bold-circle"></i>}
                                </span>
                                : null
                            : null
                    }
                    {arryactions ?
                        arryactions.filter(item => item !== 'Get').length > 0 ?

                            <Dropdown >
                                <Dropdown.Toggle variant="success" id={item.id.toString()}>
                                    <i className="mdi icon-sm mdi-table-edit"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu alignRight>
                                    {
                                        arryactions ?
                                            arryactions.includes("Delete") ?
                                                <Dropdown.Item onClick={handleShow} style={{ color: 'red' }} >
                                                    حذف  <i className="mdi icon-sm mdi-delete"></i>
                                                </Dropdown.Item >

                                                : null

                                            : accessPage.includes("Delete") ?
                                                <Dropdown.Item onClick={handleShow} style={{ color: 'red' }} >
                                                    حذف  <i className="mdi icon-sm mdi-delete"></i>
                                                </Dropdown.Item >
                                                : null
                                    }

                                    {

                                        arryactions ?
                                            arryactions.includes("Update") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelEditbtn(item.id)}>
                                                    ویرایش <i className="mdi mdi-pencil"></i>
                                                </Dropdown.Item>
                                                : null
                                            :
                                            accessPage.includes("Update") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelEditbtn(item.id)}>
                                                    ویرایش <i className="mdi mdi-pencil"></i>
                                                </Dropdown.Item>

                                                : null
                                    }
                                    {
                                        urldata ? null
                                            :
                                            accessPage.includes("Profile") ?
                                                <Dropdown.Item style={{ color: 'blue' }} onClick={() => handelview(item.id)}>
                                                    مشاهد <i className="mdi mdi-eye"></i>
                                                </Dropdown.Item>
                                                : null
                                    }
                                    {

                                        arryactions ?
                                            arryactions.includes("GetConfirm") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelshowWork(item.id)}>
                                                    وضعیت کار
                                       </Dropdown.Item>
                                                : null
                                            :
                                            accessPage.includes("GetConfirm") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelshowWork(item.id)}>
                                                    وضعیت کار
                                       </Dropdown.Item>

                                                : null
                                    }

                                </Dropdown.Menu>
                            </Dropdown>
                            : null
                        : accessPage.filter(item => item !== 'Get').length > 0 ?
                            <Dropdown >
                                <Dropdown.Toggle variant="success" id={item.id.toString()}>
                                    <i className="mdi icon-sm mdi-table-edit"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu alignRight>
                                    {
                                        arryactions ?
                                            arryactions.includes("Delete") ?
                                                <Dropdown.Item onClick={handleShow} style={{ color: 'red' }} >
                                                    حذف  <i className="mdi icon-sm mdi-delete"></i>
                                                </Dropdown.Item >

                                                : null

                                            : accessPage.includes("Delete") ?
                                                <Dropdown.Item onClick={handleShow} style={{ color: 'red' }} >
                                                    حذف  <i className="mdi icon-sm mdi-delete"></i>
                                                </Dropdown.Item >
                                                : null
                                    }

                                    {

                                        arryactions ?
                                            arryactions.includes("Update") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelEditbtn(item.id)}>
                                                    ویرایش <i className="mdi mdi-pencil"></i>
                                                </Dropdown.Item>
                                                : null
                                            :
                                            accessPage.includes("Update") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelEditbtn(item.id)}>
                                                    ویرایش <i className="mdi mdi-pencil"></i>
                                                </Dropdown.Item>

                                                : null
                                    }
                                    {
                                        urldata ? null
                                            :
                                            accessPage.includes("Profile") ?
                                                <Dropdown.Item style={{ color: 'blue' }} onClick={() => handelview(item.id)}>
                                                    مشاهد <i className="mdi mdi-eye"></i>
                                                </Dropdown.Item>
                                                : null
                                    }
                                    {

                                        arryactions ?
                                            arryactions.includes("GetConfirm") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelshowWork(item.id)}>
                                                    وضعیت کار
                                       </Dropdown.Item>
                                                : null
                                            :
                                            accessPage.includes("GetConfirm") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelshowWork(item.id)}>
                                                    وضعیت کار
                                       </Dropdown.Item>

                                                : null
                                    }

                                </Dropdown.Menu>
                            </Dropdown>
                            : null
                    }

                </td>
                <td style={{ border: '1px solid #130101' }} >{number + 1}</td>
                {
                    Object.keys(item).length > 0 ?
                        Object.keys(item).length > 10 ?
                            Object.keys(item).slice(0, 10).map((td, index) => (
                                td === 'id' ? null :
                                    td === 'transactionStatus' ? null :
                                        td === 'name' ?
                                            location.pathname === '/AccountBalance' ?
                                                <td style={{ border: '1px solid #130101' }}>
                                                    <Link to={`/Worker/${item.id}`} target="_blank" >
                                                        {item[td]}
                                                    </Link>
                                                </td>
                                                :
                                                <td style={{ border: '1px solid #130101' }} onClick={() => handelCopy(item[td])} key={index} >{item[td]}</td>


                                            :
                                            typeof item[td] === 'boolean' ?
                                                <td key={index} style={{ border: '1px solid #130101' }} >{item[td] ? <i className="fa fa-check"></i>
                                                    : <i className="fa fa-times"></i>}
                                                </td>
                                                    : td.search("Amount") > -1 || td.search("amount") > -1 || td.search("accountBalance") > -1 || td.search("AccountBalance") > -1 ||  td.search("totalDebt") > -1 || td.search("totalDebt") > -1 ?
                                                    <td onClick={() => handelCopy(item[td])} key={index}style={{ border: '1px solid #130101' }} >{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 16 }).format(parseFloat(item[td]))}</td>
                                                    :
                                                    <td onClick={() => handelCopy(item[td])} key={index} style={{ border: '1px solid #130101' }} >{item[td]}</td>

                            ))

                            : Object.keys(item).map((td, index) => (
                                td === 'id' ? null :
                                    td === 'transactionStatus' ? null :
                                        td === 'name' ?
                                            location.pathname === '/AccountBalance' ?
                                                <td style={{ border: '1px solid #130101' }}>
                                                    <Link to={`/Worker/${item.id}`} target="_blank" >
                                                        {item[td]}
                                                    </Link>
                                                </td>
                                                :
                                                <td onClick={() => handelCopy(item[td])} key={index} style={{ border: '1px solid #130101' }} >{item[td]}</td>


                                            :
                                            typeof item[td] === 'boolean' ?
                                                <td key={index} style={{ border: '1px solid #130101' }} >{item[td] ? <i className="fa fa-check"></i>
                                                    : <i className="fa fa-times"></i>}
                                                </td>
                                               : td.search("Amount") > -1 || td.search("amount") > -1 || td.search("accountBalance") > -1 || td.search("AccountBalance") > -1 ||  td.search("totalDebt") > -1 || td.search("totalDebt") > -1 ?
                                                    <td onClick={() => handelCopy(item[td])} key={index} style={{ border: '1px solid #130101' }} >{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 16 }).format(parseFloat(item[td]))}</td>
                                                    :
                                                    <td onClick={() => handelCopy(item[td])} key={index} style={{ border: '1px solid #130101' }} >{item[td]}</td>

                            ))
                        : null
                }
            </tr>
            {
                moreitem ?

                    <Row className='p-2' >
                        {
                            arryheder.map((HederHelmet, index) =>
                                <Col lg='12' md='12' sm='12' className='d-flex' >
                                    <p>{HederHelmet.label}</p>
                                    <span className='mr-1 ml-1'> : </span>
                                    {
                                        typeof keyarry[index + 8] === 'boolean' ?
                                            <p >{keyarry[index + 8] ? <i className="fa fa-check"></i>
                                                : <i className="fa fa-times"></i>
                                            }</p>
                                            : <p onClick={() => handelCopy(keyarry[index + 8])} > {keyarry[index + 8]}</p>
                                    }
                                </Col>
                            )
                        }
                    </Row>

                    : null
            }
            {
                show ?
                    <ModalDelete showitem={show}
                        handeldeleteModal={handeldelete}
                        handleCloseMoudal={handleClose}
                        urldata={urldata}
                        id={item.id} />
                    : null
            }
        </>
    )
}

